import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipTogetherButton: {
    defaultMessage: 'Combine Shipments',
    description: 'alertHeader.combineShipments',
    id: 'T6QHDy',
  },
});
